import trackCustomGA4Event from "./utils/GA4EventHelpers/trackCustomGA4Event";

const href = window.location.href;
const hrefParts = href.split("?");
const strParams = (hrefParts && hrefParts.length > 1) ? hrefParts[1] : "";
const paramsParts = strParams.split("&");

const params: Record<string, string> = {};

paramsParts.forEach((part) => {
  const param = part.split("=");
  if (param && param.length === 2) {
    params[param[0]] = param[1];
  }
});

const paramLanguage = params["lang"];
const activePrefLang = localStorage.getItem("prefLang");

let language = activePrefLang || "en";

if (paramLanguage && ["en", "fr"].includes(paramLanguage)) {
  language = paramLanguage;

  if (activePrefLang !== paramLanguage) {
    localStorage.setItem("prefLang", paramLanguage);
    trackCustomGA4Event("user_language_selection", {
      selected_language: paramLanguage === "en" ? "English" : "French"
    });
  }
}

console.log("paramLanguage", paramLanguage);
console.log("language", language);

export default language;